import image1 from "../assets/img/service/services-1.jpg";
import image2 from "../assets/img/service/services-2.jpg";
import image3 from "../assets/img/service/services-3.jpg";
import image4 from "../assets/img/service/services-4.jpg";
import image5 from "../assets/img/service/services-5.jpg";
import image6 from "../assets/img/service/services-6.jpg";

import icon1 from "../assets/img/service/engineering.jpg";
import icon2 from "../assets/img/service/architecture.jpg";
import icon3 from "../assets/img/service/construction.jpg";
import icon4 from "../assets/img/service/consultancy.jpg";
import icon5 from "../assets/img/service/import.jpg";

const servicesData = [
    {
        id: 'engineering',
        icon: icon1,
        title: 'Engineering',
        description: 'We provide expert flooring installation services, ensuring high-quality materials and precise craftsmanship for a beautiful and durable finish in your space.',
        number: '1',
        image: image1,
    },
    {
        id: 'architecture',
        icon: icon2,
        title: 'Architectural',
        description: 'Our interior design services transform spaces with innovative concepts, tailored aesthetics, and functional layouts that reflect your unique style.',
        number: '2',
        image: image2,
    },
    {
        id: 'construction',
        icon: icon3,
        title: 'Construction',
        description: 'We specialize in house renovation, revitalizing your home with modern upgrades while maintaining its character, enhancing both comfort and value.',
        number: '3',
        image: image3,
    },
    {
        id: 'consultancy',
        icon: icon4,
        title: 'Consultancy',
        description: 'We provide expert flooring installation services, ensuring high-quality materials and precise craftsmanship for a beautiful and durable finish in your space.',
        number: '4',
        image: image4,
    },
    {
        id: 'import-supply',
        icon: icon5,
        title: 'Import & Supply',
        description: 'Our team of seasoned consultants collaborates closely',
        number: '5',
        image: image5,
    },
    // {
    //     id: 'construction-planning',
    //     icon: <i className="flaticon-idea-1"></i>,
    //     title: 'Real State & Development',
    //     description: 'This can involve orientation for new hires, skill development,',
    //     number: '6',
    //     image: image6,
    // },
];

export default servicesData;